import { gql } from '@apollo/client';

export const mutationCreateServiceRequest = gql`
    mutation createServiceRequestV2($serviceData: CreateServiceRequestInputV2!) {
        createServiceRequestV2(serviceData: $serviceData) {
            id
        }
    }
`;
